<script setup>
import { computed } from 'vue';
import { groupSessionsByWeek, scheduleLineParts } from '@/js/core/utils/courses';

const props = defineProps({
  sessions: {
    type: Array,
    required: true,
  },
});

const weeks = computed(() =>
  groupSessionsByWeek(props.sessions).map(week =>
    week.map(session => ({
      key: `${session.date}-${session.time}`,
      ...scheduleLineParts(session),
    }))
  )
);
</script>

<template>
  <div class="course-modal__schedule">
    <div v-for="(week, weekIndex) in weeks" :key="weekIndex" class="course-modal__schedule-week">
      <div v-for="line in week" :key="line.key" class="course-modal__schedule-line">
        <span>{{ line.start }}</span>
        <template v-if="line.end">
          <span class="course-modal__schedule-separator">–</span>
          <span>{{ line.end }}</span>
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
